import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import TestImage from '../../images/logo1.svg';
import LightBox from 'components/LightBox/LightBox';
import { BASE_URL } from 'utils/constants';
import parse from 'html-react-parser';

const SingleArticlePage = () => {
  const [article, setArticle] = useState(null);
  const params = useParams();

  useEffect(() => {
    Axios.get(`${BASE_URL}/api/articles/` + params.id).then(({ data }) => {
      setArticle(data);
    });
  }, [params.id]);

  return (
    <div>
      {article && (
        <div className="single-news">
          <h2 className="text-center">{article.title}</h2>
          <label className=" text-center single-news-info-date">
            {article.date}
          </label>
          {article.images.length > 0 ? (
            <LightBox images={article.images} />
          ) : (
              <img className="text-center" src={TestImage} alt="single-article" />
            )}
          {article.description && (
            <p className="single-news-info-text">
              {parse(article.description)}
            </p>
          )}
          {article.link && (
            <p className="single-news-info-text ">
              Pogledajte emisiju:{' '}
              <a className="article-link" href={article.link}>
                {article.link}
              </a>
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default SingleArticlePage;
